export const extractParametersFromAddress = (
  address: string | undefined,
): { protocol: string | null; domain: string | null; path: string | null } => {
  if (!address) return { protocol: null, domain: null, path: null };

  const splitAddress: string[] = address.split('://');
  const protocol = splitAddress[0] || null;
  const splitAddress2 = splitAddress[1] ? splitAddress[1].split('/') : null;
  const domain = splitAddress2![0] || null;
  const path = splitAddress2![1] ? splitAddress2!.slice(1).join('/') : null;

  return {
    protocol,
    domain,
    path,
  };
};
